var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconPayMent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C3.79086 4 2 5.79086 2 8V16C2 18.2091 3.79086 20 6 20H10C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18H6C4.89543 18 4 17.1046 4 16V11H20V11.5C20 12.0523 20.4477 12.5 21 12.5C21.5523 12.5 22 12.0523 22 11.5V8C22 5.79086 20.2091 4 18 4H6ZM20 8C20 6.89543 19.1046 6 18 6H6C4.89543 6 4 6.89543 4 8L20 8Z",
    fill: "#121922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17C12 14.2384 14.2384 12 17 12C19.7616 12 22 14.2384 22 17C22 19.7616 19.7616 22 17 22C14.2384 22 12 19.7616 12 17ZM20.2022 16.169C20.5716 15.8365 20.6016 15.2674 20.2691 14.8979C19.9365 14.5285 19.3675 14.4985 18.998 14.831L16.2668 17.2892L15.2022 16.331C14.8327 15.9985 14.2636 16.0285 13.9311 16.3979C13.5986 16.7674 13.6286 17.3365 13.998 17.669L15.6647 19.169C16.007 19.477 16.5265 19.477 16.8688 19.169L20.2022 16.169Z",
    fill: "#121922"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaller);
export default __webpack_public_path__ + "static/media/IconWaller.964ff072871b4046e6419cd0033f5e3b.svg";
export { ForwardRef as ReactComponent };